import { CustomDialog } from './CustomDialog';

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  description: string;
  onClose: () => void;
  onConfirm: () => void;
}

export function ConfirmDialog(props: Readonly<ConfirmDialogProps>) {
  const { isOpen, title, description, onClose, onConfirm } = props;

  return (
    <CustomDialog
      isOpen={isOpen}
      title={title}
      submitButtonText="Confirm"
      onClose={onClose}
      onSubmit={onConfirm}
    >
      {description}
    </CustomDialog>
  );
}
